// Utilitário de tracking preparado para Meta Pixel, Kwai Pixel e Google Analytics.
// Preencha os IDs abaixo (placeholders) com os valores reais.

export const META_PIXEL_ID = "SEU_META_PIXEL_ID";
export const KWAI_PIXEL_ID = "SEU_KWAI_PIXEL_ID";
export const GA_MEASUREMENT_ID = "SEU_GA_MEASUREMENT_ID";

type DataLayerObject = { event: string; [key: string]: unknown };

declare global {
  interface Window {
    dataLayer?: DataLayerObject[];
    gtag?: (...args: unknown[]) => void;
    fbq?: (...args: unknown[]) => void;
    kwaiTrack?: (eventName: string, params?: Record<string, unknown>) => void;
  }
}

function injectScript(src: string): void {
  const script = document.createElement("script");
  script.src = src;
  script.async = true;
  document.head.appendChild(script);
}

/** Inicializa os pixels apenas quando os IDs reais forem informados. */
export function initTracking(): void {
  // Google Analytics (gtag) — pode ser gerenciado também pela integração nativa.
  if (GA_MEASUREMENT_ID !== "SEU_GA_MEASUREMENT_ID" && !window.gtag) {
    injectScript(`https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag(...args: unknown[]) {
      window.dataLayer?.push(args as unknown as DataLayerObject);
    };
    window.gtag("js", new Date());
    window.gtag("config", GA_MEASUREMENT_ID);
  }

  // Meta Pixel
  if (META_PIXEL_ID !== "SEU_META_PIXEL_ID" && !window.fbq) {
    window.fbq = function fbq(...args: unknown[]) {
      // Base code simplificada — o ID real deve ser configurado no Meta Events Manager.
      void args;
    };
    injectScript(`https://connect.facebook.net/en_US/fbevents.js`);
  }

  // Kwai Pixel
  if (KWAI_PIXEL_ID !== "SEU_KWAI_PIXEL_ID" && !window.kwaiTrack) {
    window.kwaiTrack = function kwaiTrack(eventName: string, params?: Record<string, unknown>) {
      // Integração com o Kwai Pixel — configure conforme a documentação da plataforma.
      void eventName;
      void params;
    };
  }
}

/** Dispara um evento de tracking genérico (dataLayer + pixels). */
export function trackEvent(name: string, params?: Record<string, unknown>): void {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: name, ...(params || {}) });

  if (window.fbq) {
    window.fbq("trackCustom", name, params);
  }
  if (window.kwaiTrack) {
    window.kwaiTrack(name, params);
  }
}

/** Rastreia cliques em CTAs, preservando UTMs quando presente na URL. */
export function trackCta(label: string): void {
  const params = new URLSearchParams(window.location.search);
  const utm: Record<string, unknown> = {};
  ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"].forEach((key) => {
    const value = params.get(key);
    if (value) utm[key] = value;
  });
  trackEvent("cta_click", { cta_label: label, ...utm });
}

/** Rastreia a conclusão do formulário de análise. */
export function trackLead(): void {
  trackEvent("lead_submit", { form: "analise_kwai_ads" });
}